import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table as Table2,
    Pagination,
    Checkbox,
    Modal,
    Upload,
    Radio,
    Transfer,
    Form,
    Col,
    Rate,
    Divider,
    Tree,
    message
} from 'antd';
import { Redirect, Link, withRouter } from 'react-router-dom';
import store from "../store/store.js";
import moment from 'moment';

const { RangePicker } = DatePicker;
const { Option, OptGroup } = Select;

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {}
        }
    }

    componentDidMount() {
        this.props.NAV_CHANGE('/setting', ['首页', '系统设置'])
        this.getdata()
    }

    getdata = () => {
        let that = this
        // var arr = that.state.condition
        fetch('/Setting/index', {
            // post提交
            method: "POST",
            body: JSON.stringify({
                yuanqu: store.getState().data.yuanqu ? store.getState().data.yuanqu : null
            })
        })
            .then(res => res.json())
            .then(data => {
                that.setState({
                    condition: data.data,
                })
            })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, { [name]: value })
        this.setState({
            condition: data
        })
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, { [name]: value })
        this.setState({
            condition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Option value={item.id} key={index}>{item.name}</Option>
            )
        }
    }

    sub() {
        let that = this
        that.setState({
            loading: true
        })
        fetch('/Setting/doview', {
            method: "POST",
            body: JSON.stringify(that.state.condition)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    message.success(data.msg)
                    that.getdata()
                } else {
                    message.error(data.msg)
                }
                that.setState({
                    loading: false
                })
            })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(dates, dateStrings)
        let data = Object.assign({}, this.state.condition, {
            [name + '_stime']: dateStrings[0],
            [name + '_etime']: dateStrings[1]
        })
        this.setState({
            condition: data
        })
    }

    render() {

        return (
            <>
                <div className={'view_box'}>
                    <div className={'view_title'}>供暖费缴费标准</div>
                    <Form
                        layout="vertical"
                        // labelCol={{ span: 4 }}
                        wrapperCol={{ span: 24 }}
                        style={{ width: 1000 }}
                    >
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label=" "
                                >
                                    <span style={{ fontWeight: "bold" }}>创意产业园</span>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={10}>
                                <Form.Item
                                    label="供暖时间"
                                >
                                    <RangePicker style={{ width: '100%' }} allowEmpty={[true, true]}
                                        onChange={this.onRangeChange.bind(this, 'gn_cy')}
                                        value={[(this.state.condition.gn_cy_stime ? moment(this.state.condition.gn_cy_stime) : null), (this.state.condition.gn_cy_etime ? moment(this.state.condition.gn_cy_etime) : null)]}
                                        placeholder={['请输入', '请输入']} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="金额"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'元/㎡/季'}
                                        placeholder="请输入"
                                        value={this.state.condition.gn_cy_amount ? this.state.condition.gn_cy_amount : null}
                                        onChange={this.onChange.bind(this, 'gn_cy_amount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="供暖报停费"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'%'}
                                        placeholder="请输入"
                                        value={this.state.condition.gn_cy_samount ? this.state.condition.gn_cy_samount : null}
                                        onChange={this.onChange.bind(this, 'gn_cy_samount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label=" "
                                >
                                    <span style={{ fontWeight: "bold" }}>检测认证园</span>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={10}>
                                <Form.Item
                                    label="供暖时间"
                                >
                                    <RangePicker style={{ width: '100%' }} allowEmpty={[true, true]}
                                        onChange={this.onRangeChange.bind(this, 'gn_jc')}
                                        value={[(this.state.condition.gn_jc_stime ? moment(this.state.condition.gn_jc_stime) : null), (this.state.condition.gn_jc_etime ? moment(this.state.condition.gn_jc_etime) : null)]}
                                        placeholder={['请输入', '请输入']} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="金额"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'元/㎡/季'}
                                        placeholder="请输入"
                                        value={this.state.condition.gn_jc_amount ? this.state.condition.gn_jc_amount : null}
                                        onChange={this.onChange.bind(this, 'gn_jc_amount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="供暖报停费"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'%'}
                                        placeholder="请输入"
                                        value={this.state.condition.gn_jc_samount ? this.state.condition.gn_jc_samount : null}
                                        onChange={this.onChange.bind(this, 'gn_jc_samount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label=" "
                                >
                                    <span style={{ fontWeight: "bold" }}>人工智能产业园</span>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={10}>
                                <Form.Item
                                    label="供暖时间"
                                >
                                    <RangePicker style={{ width: '100%' }} allowEmpty={[true, true]}
                                        onChange={this.onRangeChange.bind(this, 'gn_rg')}
                                        value={[(this.state.condition.gn_rg_stime ? moment(this.state.condition.gn_rg_stime) : null), (this.state.condition.gn_rg_etime ? moment(this.state.condition.gn_rg_etime) : null)]}
                                        placeholder={['请输入', '请输入']} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="金额"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'元/㎡/天'}
                                        placeholder="请输入"
                                        value={this.state.condition.gn_rg_amount ? this.state.condition.gn_rg_amount : null}
                                        onChange={this.onChange.bind(this, 'gn_rg_amount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="供暖报停费"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'%'}
                                        placeholder="请输入"
                                        value={this.state.condition.gn_rg_samount ? this.state.condition.gn_rg_samount : null}
                                        onChange={this.onChange.bind(this, 'gn_rg_samount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label=" "
                                >
                                    <span style={{ fontWeight: "bold" }}>测试场</span>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={10}>
                                <Form.Item
                                    label="供暖时间"
                                >
                                    <RangePicker style={{ width: '100%' }} allowEmpty={[true, true]}
                                        onChange={this.onRangeChange.bind(this, 'gn_cs')}
                                        value={[(this.state.condition.gn_cs_stime ? moment(this.state.condition.gn_cs_stime) : null), (this.state.condition.gn_cs_etime ? moment(this.state.condition.gn_cs_etime) : null)]}
                                        placeholder={['请输入', '请输入']} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="金额"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'元/㎡'}
                                        placeholder="请输入"
                                        value={this.state.condition.gn_cs_amount ? this.state.condition.gn_cs_amount : null}
                                        onChange={this.onChange.bind(this, 'gn_cs_amount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="供暖报停费"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'%'}
                                        placeholder="请输入"
                                        value={this.state.condition.gn_cs_samount ? this.state.condition.gn_cs_samount : null}
                                        onChange={this.onChange.bind(this, 'gn_cs_samount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label=" "
                                >
                                    <span style={{ fontWeight: "bold" }}>福宝产业园</span>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={10}>
                                <Form.Item
                                    label="供暖时间"
                                >
                                    <RangePicker style={{ width: '100%' }} allowEmpty={[true, true]}
                                        onChange={this.onRangeChange.bind(this, 'gn_fb')}
                                        value={[(this.state.condition.gn_fb_stime ? moment(this.state.condition.gn_fb_stime) : null), (this.state.condition.gn_fb_etime ? moment(this.state.condition.gn_fb_etime) : null)]}
                                        placeholder={['请输入', '请输入']} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="金额"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'元/㎡'}
                                        placeholder="请输入"
                                        value={this.state.condition.gn_fb_amount ? this.state.condition.gn_fb_amount : null}
                                        onChange={this.onChange.bind(this, 'gn_fb_amount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="供暖报停费"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'%'}
                                        placeholder="请输入"
                                        value={this.state.condition.gn_fb_samount ? this.state.condition.gn_fb_samount : null}
                                        onChange={this.onChange.bind(this, 'gn_fb_samount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label=" "
                                >
                                    <span style={{ fontWeight: "bold" }}>别墅</span>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={10}>
                                <Form.Item
                                    label="供暖时间"
                                >
                                    <RangePicker style={{ width: '100%' }} allowEmpty={[true, true]}
                                        onChange={this.onRangeChange.bind(this, 'gn_bs')}
                                        value={[(this.state.condition.gn_bs_stime ? moment(this.state.condition.gn_bs_stime) : null), (this.state.condition.gn_bs_etime ? moment(this.state.condition.gn_bs_etime) : null)]}
                                        placeholder={['请输入', '请输入']} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="金额"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'元/㎡/季'}
                                        placeholder="请输入"
                                        value={this.state.condition.gn_bs_amount ? this.state.condition.gn_bs_amount : null}
                                        onChange={this.onChange.bind(this, 'gn_bs_amount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="供暖报停费"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'%'}
                                        placeholder="请输入"
                                        value={this.state.condition.gn_bs_samount ? this.state.condition.gn_bs_samount : null}
                                        onChange={this.onChange.bind(this, 'gn_bs_samount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    <div className={'view_title'}>供暖费缴费标准（续）</div>
                    <Form
                        layout="vertical"
                        // labelCol={{ span: 4 }}
                        wrapperCol={{ span: 24 }}
                        style={{ width: 1000 }}
                    >
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label=" "
                                >
                                    <span style={{ fontWeight: "bold" }}>创意产业园</span>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={10}>
                                <Form.Item
                                    label="供暖时间"
                                >
                                    <RangePicker style={{ width: '100%' }} allowEmpty={[true, true]}
                                        onChange={this.onRangeChange.bind(this, 'xu_gn_cy')}
                                        value={[(this.state.condition.xu_gn_cy_stime ? moment(this.state.condition.xu_gn_cy_stime) : null), (this.state.condition.xu_gn_cy_etime ? moment(this.state.condition.xu_gn_cy_etime) : null)]}
                                        placeholder={['请输入', '请输入']} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="金额"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'元/㎡/季'}
                                        placeholder="请输入"
                                        value={this.state.condition.xu_gn_cy_amount ? this.state.condition.xu_gn_cy_amount : null}
                                        onChange={this.onChange.bind(this, 'xu_gn_cy_amount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="供暖报停费"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'%'}
                                        placeholder="请输入"
                                        value={this.state.condition.xu_gn_cy_samount ? this.state.condition.xu_gn_cy_samount : null}
                                        onChange={this.onChange.bind(this, 'xu_gn_cy_samount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label=" "
                                >
                                    <span style={{ fontWeight: "bold" }}>检测认证园</span>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={10}>
                                <Form.Item
                                    label="供暖时间"
                                >
                                    <RangePicker style={{ width: '100%' }} allowEmpty={[true, true]}
                                        onChange={this.onRangeChange.bind(this, 'xu_gn_jc')}
                                        value={[(this.state.condition.xu_gn_jc_stime ? moment(this.state.condition.xu_gn_jc_stime) : null), (this.state.condition.xu_gn_jc_etime ? moment(this.state.condition.xu_gn_jc_etime) : null)]}
                                        placeholder={['请输入', '请输入']} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="金额"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'元/㎡/季'}
                                        placeholder="请输入"
                                        value={this.state.condition.xu_gn_jc_amount ? this.state.condition.xu_gn_jc_amount : null}
                                        onChange={this.onChange.bind(this, 'xu_gn_jc_amount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="供暖报停费"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'%'}
                                        placeholder="请输入"
                                        value={this.state.condition.xu_gn_jc_samount ? this.state.condition.xu_gn_jc_samount : null}
                                        onChange={this.onChange.bind(this, 'xu_gn_jc_samount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label=" "
                                >
                                    <span style={{ fontWeight: "bold" }}>人工智能产业园</span>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={10}>
                                <Form.Item
                                    label="供暖时间"
                                >
                                    <RangePicker style={{ width: '100%' }} allowEmpty={[true, true]}
                                        onChange={this.onRangeChange.bind(this, 'xu_gn_rg')}
                                        value={[(this.state.condition.xu_gn_rg_stime ? moment(this.state.condition.xu_gn_rg_stime) : null), (this.state.condition.xu_gn_rg_etime ? moment(this.state.condition.xu_gn_rg_etime) : null)]}
                                        placeholder={['请输入', '请输入']} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="金额"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'元/㎡/天'}
                                        placeholder="请输入"
                                        value={this.state.condition.xu_gn_rg_amount ? this.state.condition.xu_gn_rg_amount : null}
                                        onChange={this.onChange.bind(this, 'xu_gn_rg_amount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="供暖报停费"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'%'}
                                        placeholder="请输入"
                                        value={this.state.condition.xu_gn_rg_samount ? this.state.condition.xu_gn_rg_samount : null}
                                        onChange={this.onChange.bind(this, 'xu_gn_rg_samount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label=" "
                                >
                                    <span style={{ fontWeight: "bold" }}>测试场</span>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={10}>
                                <Form.Item
                                    label="供暖时间"
                                >
                                    <RangePicker style={{ width: '100%' }} allowEmpty={[true, true]}
                                        onChange={this.onRangeChange.bind(this, 'xu_gn_cs')}
                                        value={[(this.state.condition.xu_gn_cs_stime ? moment(this.state.condition.xu_gn_cs_stime) : null), (this.state.condition.xu_gn_cs_etime ? moment(this.state.condition.xu_gn_cs_etime) : null)]}
                                        placeholder={['请输入', '请输入']} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="金额"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'元/㎡'}
                                        placeholder="请输入"
                                        value={this.state.condition.xu_gn_cs_amount ? this.state.condition.xu_gn_cs_amount : null}
                                        onChange={this.onChange.bind(this, 'xu_gn_cs_amount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="供暖报停费"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'%'}
                                        placeholder="请输入"
                                        value={this.state.condition.xu_gn_cs_samount ? this.state.condition.xu_gn_cs_samount : null}
                                        onChange={this.onChange.bind(this, 'xu_gn_cs_samount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label=" "
                                >
                                    <span style={{ fontWeight: "bold" }}>福宝产业园</span>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={10}>
                                <Form.Item
                                    label="供暖时间"
                                >
                                    <RangePicker style={{ width: '100%' }} allowEmpty={[true, true]}
                                        onChange={this.onRangeChange.bind(this, 'xu_gn_fb')}
                                        value={[(this.state.condition.xu_gn_fb_stime ? moment(this.state.condition.xu_gn_fb_stime) : null), (this.state.condition.xu_gn_fb_etime ? moment(this.state.condition.xu_gn_fb_etime) : null)]}
                                        placeholder={['请输入', '请输入']} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="金额"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'元/㎡'}
                                        placeholder="请输入"
                                        value={this.state.condition.xu_gn_fb_amount ? this.state.condition.xu_gn_fb_amount : null}
                                        onChange={this.onChange.bind(this, 'xu_gn_fb_amount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="供暖报停费"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'%'}
                                        placeholder="请输入"
                                        value={this.state.condition.xu_gn_fb_samount ? this.state.condition.xu_gn_fb_samount : null}
                                        onChange={this.onChange.bind(this, 'xu_gn_fb_samount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label=" "
                                >
                                    <span style={{ fontWeight: "bold" }}>别墅</span>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={10}>
                                <Form.Item
                                    label="供暖时间"
                                >
                                    <RangePicker style={{ width: '100%' }} allowEmpty={[true, true]}
                                        onChange={this.onRangeChange.bind(this, 'xu_gn_bs')}
                                        value={[(this.state.condition.xu_gn_bs_stime ? moment(this.state.condition.xu_gn_bs_stime) : null), (this.state.condition.xu_gn_bs_etime ? moment(this.state.condition.xu_gn_bs_etime) : null)]}
                                        placeholder={['请输入', '请输入']} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="金额"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'元/㎡/季'}
                                        placeholder="请输入"
                                        value={this.state.condition.xu_gn_bs_amount ? this.state.condition.xu_gn_bs_amount : null}
                                        onChange={this.onChange.bind(this, 'xu_gn_bs_amount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="供暖报停费"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'%'}
                                        placeholder="请输入"
                                        value={this.state.condition.xu_gn_bs_samount ? this.state.condition.xu_gn_bs_samount : null}
                                        onChange={this.onChange.bind(this, 'xu_gn_bs_samount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    <div className={'view_title'}>制冷费缴费标准</div>
                    <Form
                        layout="vertical"
                        // labelCol={{ span: 4 }}
                        wrapperCol={{ span: 24 }}
                        style={{ width: 1000 }}
                    >
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label=" "
                                >
                                    <span style={{ fontWeight: "bold" }}>创意产业园</span>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={10}>
                                <Form.Item
                                    label="制冷时间"
                                >
                                    <RangePicker style={{ width: '100%' }} allowEmpty={[true, true]}
                                        onChange={this.onRangeChange.bind(this, 'zl_cy')}
                                        value={[(this.state.condition.zl_cy_stime ? moment(this.state.condition.zl_cy_stime) : null), (this.state.condition.zl_cy_etime ? moment(this.state.condition.zl_cy_etime) : null)]}
                                        placeholder={['请输入', '请输入']} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="金额"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'元/㎡/季'}
                                        placeholder="请输入"
                                        value={this.state.condition.zl_cy_amount ? this.state.condition.zl_cy_amount : null}
                                        onChange={this.onChange.bind(this, 'zl_cy_amount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="制冷报停费"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'%'}
                                        placeholder="请输入"
                                        value={this.state.condition.zl_cy_samount ? this.state.condition.zl_cy_samount : null}
                                        onChange={this.onChange.bind(this, 'zl_cy_samount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label=" "
                                >
                                    <span style={{ fontWeight: "bold" }}>检测认证园</span>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={10}>
                                <Form.Item
                                    label="制冷时间"
                                >
                                    <RangePicker style={{ width: '100%' }} allowEmpty={[true, true]}
                                        onChange={this.onRangeChange.bind(this, 'zl_jc')}
                                        value={[(this.state.condition.zl_jc_stime ? moment(this.state.condition.zl_jc_stime) : null), (this.state.condition.zl_jc_etime ? moment(this.state.condition.zl_jc_etime) : null)]}
                                        placeholder={['请输入', '请输入']} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="金额"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'元/㎡/季'}
                                        placeholder="请输入"
                                        value={this.state.condition.zl_jc_amount ? this.state.condition.zl_jc_amount : null}
                                        onChange={this.onChange.bind(this, 'zl_jc_amount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="制冷报停费"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'%'}
                                        placeholder="请输入"
                                        value={this.state.condition.zl_jc_samount ? this.state.condition.zl_jc_samount : null}
                                        onChange={this.onChange.bind(this, 'zl_jc_samount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label=" "
                                >
                                    <span style={{ fontWeight: "bold" }}>人工智能产业园</span>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={10}>
                                <Form.Item
                                    label="制冷时间"
                                >
                                    <RangePicker style={{ width: '100%' }} allowEmpty={[true, true]}
                                        onChange={this.onRangeChange.bind(this, 'zl_rg')}
                                        value={[(this.state.condition.zl_rg_stime ? moment(this.state.condition.zl_rg_stime) : null), (this.state.condition.zl_rg_etime ? moment(this.state.condition.zl_rg_etime) : null)]}
                                        placeholder={['请输入', '请输入']} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="金额"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'元/㎡/天'}
                                        placeholder="请输入"
                                        value={this.state.condition.zl_rg_amount ? this.state.condition.zl_rg_amount : null}
                                        onChange={this.onChange.bind(this, 'zl_rg_amount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="制冷报停费"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'%'}
                                        placeholder="请输入"
                                        value={this.state.condition.zl_rg_samount ? this.state.condition.zl_rg_samount : null}
                                        onChange={this.onChange.bind(this, 'zl_rg_samount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label=" "
                                >
                                    <span style={{ fontWeight: "bold" }}>测试场</span>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={10}>
                                <Form.Item
                                    label="制冷时间"
                                >
                                    <RangePicker style={{ width: '100%' }} allowEmpty={[true, true]}
                                        onChange={this.onRangeChange.bind(this, 'zl_cs')}
                                        value={[(this.state.condition.zl_cs_stime ? moment(this.state.condition.zl_cs_stime) : null), (this.state.condition.zl_cs_etime ? moment(this.state.condition.zl_cs_etime) : null)]}
                                        placeholder={['请输入', '请输入']} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="金额"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'元/㎡'}
                                        placeholder="请输入"
                                        value={this.state.condition.zl_cs_amount ? this.state.condition.zl_cs_amount : null}
                                        onChange={this.onChange.bind(this, 'zl_cs_amount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="制冷报停费"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'%'}
                                        placeholder="请输入"
                                        value={this.state.condition.zl_cs_samount ? this.state.condition.zl_cs_samount : null}
                                        onChange={this.onChange.bind(this, 'zl_cs_samount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                        </Row>
                        
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label=" "
                                >
                                    <span style={{ fontWeight: "bold" }}>福宝产业园</span>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={10}>
                                <Form.Item
                                    label="制冷时间"
                                >
                                    <RangePicker style={{ width: '100%' }} allowEmpty={[true, true]}
                                        onChange={this.onRangeChange.bind(this, 'zl_fb')}
                                        value={[(this.state.condition.zl_fb_stime ? moment(this.state.condition.zl_fb_stime) : null), (this.state.condition.zl_fb_etime ? moment(this.state.condition.zl_fb_etime) : null)]}
                                        placeholder={['请输入', '请输入']} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="金额"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'元/㎡'}
                                        placeholder="请输入"
                                        value={this.state.condition.zl_fb_amount ? this.state.condition.zl_fb_amount : null}
                                        onChange={this.onChange.bind(this, 'zl_fb_amount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="制冷报停费"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'%'}
                                        placeholder="请输入"
                                        value={this.state.condition.zl_fb_samount ? this.state.condition.zl_fb_samount : null}
                                        onChange={this.onChange.bind(this, 'zl_fb_samount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                            
                        </Row>
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label=" "
                                >
                                    <span style={{ fontWeight: "bold" }}>别墅</span>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={10}>
                                <Form.Item
                                    label="制冷时间"
                                >
                                    <RangePicker style={{ width: '100%' }} allowEmpty={[true, true]}
                                        onChange={this.onRangeChange.bind(this, 'zl_bs')}
                                        value={[(this.state.condition.zl_bs_stime ? moment(this.state.condition.zl_bs_stime) : null), (this.state.condition.zl_bs_etime ? moment(this.state.condition.zl_bs_etime) : null)]}
                                        placeholder={['请输入', '请输入']} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="金额"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'元/㎡/季'}
                                        placeholder="请输入"
                                        value={this.state.condition.zl_bs_amount ? this.state.condition.zl_bs_amount : null}
                                        onChange={this.onChange.bind(this, 'zl_bs_amount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={5}>
                                <Form.Item
                                    label="制冷报停费"
                                >
                                    <Input className="input" type={'number'} min={0} step={0.01} suffix={'%'}
                                        placeholder="请输入"
                                        value={this.state.condition.zl_bs_samount ? this.state.condition.zl_bs_samount : null}
                                        onChange={this.onChange.bind(this, 'zl_bs_samount')} autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" offset={4} span={20}>
                                <Form.Item>
                                    <Row justify={"start"}>
                                        <Button type='primary' onClick={this.sub.bind(this)}
                                            loading={this.state.loading}>提交</Button>
                                    </Row>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </>
        )
    }
}

export default Index
